import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useMemo } from 'react'
import invariant from 'tiny-invariant'

/**
 * Returns the available features associated with a given phase. These are derived
 * as part of the 'post action stage' of the Cube reducer, as part of queries.
 *
 * Ultimately, the calculation around available features would be better suited
 * being refactored and moved to this hook and colocated with the phase.
 * The key advantage of the current, reducer heavy, setup is the insights
 * available into the state using the cube developer logs. We will, therefore,
 * likely change over to something like Jotai as part of said refactor and ensure
 * that the devtools are set up in a way to provide those insights/visibility.
 * @param props
 * @returns
 */
export const useAvailableFeaturesForPhase = (props: { phaseId: string }) => {
  const cubeContext = useCubeContext()
  const availableFeaturesForPhase = useMemo(() => {
    return cubeContext.queries.availableFeatures.phases[props.phaseId]
  }, [cubeContext.queries.availableFeatures, props.phaseId])

  invariant(availableFeaturesForPhase, 'Available features for phase not found')

  return {
    availableFeaturesForPhase
  }
}
